module.exports = __webpack_public_path__ + "media/src/img/payment/kseniya_tinkoff_qr-a45469accb87eee219cd2b708fcf099e.png";